module.exports = __webpack_public_path__ + "static/media/list_words_ru.21304de7.jpg";